import { render } from "./Shell.component.vue?vue&type=template&id=68750817"
import script from "./Shell.component.vue?vue&type=script&lang=js"
export * from "./Shell.component.vue?vue&type=script&lang=js"

import "./Shell.component.vue?vue&type=style&index=0&id=68750817&lang=css"

import exportComponent from "/home/debian/oni-ui/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__